import type { ColumnDef } from '@tanstack/react-table';
import { requestTypeLabelMap } from '~/common/dataRequestUtils';
import type { DataRequestV2 } from '~/common/types';
import Checkbox from '~/components2/forms/Checkbox';

const getType = (r: DataRequestV2) => {
  return requestTypeLabelMap[r.type] || '';
};

export const columns: ColumnDef<DataRequestV2>[] = [
  {
    id: 'select',
    enableSorting: false,
    size: 25,
    header: 'Link',
    cell: ({ row }) => {
      return (
        <div className="flex w-full items-center justify-center">
          <Checkbox label="" value={row.getIsSelected()} checked={row.getIsSelected()} onChange={row.toggleSelected} />
        </div>
      );
    },
  },
  {
    id: 'requestId',
    header: 'Request ID',
    accessorKey: 'requestId',
  },
  {
    id: 'agencyName',
    header: 'Agency',
    accessorFn: (r) => r.agency.agencyName,
  },
  {
    id: 'type',
    header: 'Asset',
    accessorFn: (r) => r.agency.type,
  },
  {
    id: 'requestType',
    header: 'Request Type',
    accessorFn: getType,
  },
];
